import { useCallback, useMemo, useState } from "react";
import { _ } from "i18n";
import type { Keys } from "i18n/locales/types";
import { useStore } from "../store";
import { FilterCategory } from "../types";

export function useStatsPeriodSelection(gameId: number) {
	const eventFilter = useStore((state) => state.eventFilter);

	const periodTabs = useMemo(() => {
		if (eventFilter === null || eventFilter === undefined) {
			return [];
		}

		return eventFilter.getFilterViewsByCategories([FilterCategory.Period]).map((filterView) => ({
			key: filterView.value,
			label: _(filterView.label as keyof Keys),
		}));
	}, [eventFilter]);

	const availablePeriodKeys = useMemo(
		() => periodTabs.map((periodTab) => periodTab.key),
		[periodTabs],
	);

	const [userSelectedPeriods, setUserSelectedPeriods] = useState<{ gameId: number; keys: string[] } | null>(null);

	const periods = useMemo(() => {
		if (userSelectedPeriods !== null && userSelectedPeriods.gameId === gameId) {
			return userSelectedPeriods.keys;
		}

		return availablePeriodKeys;
	}, [availablePeriodKeys, gameId, userSelectedPeriods]);

	const isEventFilterHydrated = eventFilter !== null && eventFilter.filterViews.length > 0;

	const handlePeriodsChange = useCallback(
		(keys: (string | number)[]) => {
			setUserSelectedPeriods({ gameId, keys: keys as string[] });
		},
		[gameId],
	);

	return {
		eventFilter,
		periodTabs,
		periods,
		availablePeriodKeys,
		isEventFilterHydrated,
		handlePeriodsChange,
	};
}
